export default __webpack_public_path__ + "static/media/Arte_Juicio305_V3.f0326355.png";